<template>
	<div>
		<RichTextComponent v-if="showDisclaimer" :class="disclaimerClasses" :blocks="disclaimer" />
		<LiteratureLinkGrid class="display-block" :literature-list="props.literatureList" />
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { FundLiterature } from 'types/funds';
import LiteratureLinkGrid from '@components/offering-details/literature-link-grid.vue';
import RichTextComponent from '@components/sanity/rich-text-component.vue';
import { SanityRichTextBlock } from 'types/sanity';

interface Props {
	literatureList: Array<FundLiterature>;
	disclaimer: Array<SanityRichTextBlock>;
	disclaimerClasses?: string;
}

const props = defineProps<Props>();

const showDisclaimer = computed((): boolean => props.disclaimer.length > 0);
</script>
